module.exports = __webpack_public_path__ + "img/section15.1e4c9f21.png";